import { t } from "@/i18n";
import { Link } from "react-router-dom";
import { Lock, Mail, MapPin, ScanEye, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Loader";

export const BUSINESS = {
  name: "AI-GENIX PTY LTD",
  abn: "53 663 864 766",
  location: "Melbourne, VIC, Australia",
  email: "Lujostoreau@gmail.com",
  product: "PaintiPop",
};

export const Footer = () => (
  <footer className="relative z-10 bg-[#1E293B] text-slate-300 mt-16" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-12">
      <div className="md:col-span-4 space-y-4">
        <div className="inline-block bg-white rounded-2xl px-3 py-1.5"><Logo small /></div>
        <p className="text-sm leading-relaxed">{t("safe_printable_ai_colouring_pages_for_ki")}</p>
        <div className="space-y-1.5 text-sm" data-testid="footer-business-details">
          <p className="font-bold text-white">{BUSINESS.name}</p>
          <p>ABN {BUSINESS.abn}</p>
          <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#FFD166]" /> {BUSINESS.location}</p>
          <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-contact-email"><Mail className="w-4 h-4 text-[#FFD166]" /> {BUSINESS.email}</a>
        </div>
      </div>
      <div className="md:col-span-4 space-y-3" data-testid="footer-safety">
        <h3 className="font-display font-semibold text-white text-lg flex items-center gap-2"><ShieldCheck className="w-5 h-5 text-emerald-400" /> {t("child_safety_comes_first")}</h3>
        <ul className="space-y-2.5 text-sm">
          <li className="flex gap-2.5"><Lock className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" /> {t("every_idea_is_checked_by_our_safety_filt")} <b className="text-white">{t("before")}</b> {t("any_picture_is_drawn")}</li>
          <li className="flex gap-2.5"><ScanEye className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" /> {t("every_finished_picture_is_scanned_by_ai_")} <b className="text-white">{t("before")}</b> {t("a_child_can_see_it")}</li>
          <li className="flex gap-2.5"><ShieldCheck className="w-4 h-4 mt-0.5 shrink-0 text-emerald-400" /> {t("no_ads_no_chat_with_strangers_and_kids_n")}</li>
        </ul>
        <Link to="/safety" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#FFD166] hover:text-white" data-testid="footer-safety-link">{t("how_our_safety_system_works")}</Link>
      </div>
      <div className="md:col-span-2 space-y-3">
        <h3 className="font-display font-semibold text-white text-lg">{t("legal")}</h3>
        <ul className="space-y-2 text-sm">
          <li><Link to="/safety" className="hover:text-white" data-testid="footer-about-link">{t("about_safety")}</Link></li>
          <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">{t("privacy_policy")}</Link></li>
          <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">{t("terms_of_service")}</Link></li>
          <li><Link to="/refunds" className="hover:text-white" data-testid="footer-refunds-link">{t("refund_policy")}</Link></li>
          <li><a href={`mailto:${BUSINESS.email}`} className="hover:text-white">{t("contact_us")}</a></li>
        </ul>
      </div>
      <div className="md:col-span-2 space-y-3">
        <h3 className="font-display font-semibold text-white text-lg">{t("payments")}</h3>
        <div className="rounded-2xl border-2 border-slate-600 px-4 py-3 text-sm space-y-1" data-testid="footer-stripe-badge">
          <p className="font-bold text-white flex items-center gap-2"><Lock className="w-4 h-4 text-[#4ECDC4]" /> {t("secure_checkout")}</p>
          <p>{t("powered_by")} <span className="font-bold text-white">{t("stripe")}</span>{t("we_never_see_or_store_your_card_details")}</p>
        </div>
      </div>
    </div>
    <div className="border-t border-slate-700">
      <p className="max-w-7xl mx-auto px-4 sm:px-6 py-5 text-xs text-slate-400">© {new Date().getFullYear()} {BUSINESS.name} (ABN {BUSINESS.abn}). {BUSINESS.product} is a trading name of {BUSINESS.name}. Prices in AUD/USD as shown at checkout, GST included where applicable.</p>
    </div>
  </footer>
);
